module.exports = __webpack_public_path__ + "static/displacement-d-b8da763a858465259ab808951115378a.jpg";